import { Input } from "@/components/ui/input";
import { SearchCombobox } from "@/components/ui/search-combobox";
import { searchModels, searchCategories } from "@/lib/snipeit/lookups";
import type { SnipeItModel, SnipeItCategory } from "@/lib/snipeit/types";
import { Search, X } from "lucide-react";

interface AssetFilterBarProps {
  search: string;
  onSearchChange: (value: string) => void;
  modelFilter: SnipeItModel | null;
  modelInput: string;
  onModelInputChange: (value: string) => void;
  onModelSelect: (model: SnipeItModel) => void;
  onModelClear: () => void;
  categoryFilter: SnipeItCategory | null;
  categoryInput: string;
  onCategoryInputChange: (value: string) => void;
  onCategorySelect: (category: SnipeItCategory) => void;
  onCategoryClear: () => void;
}

export function AssetFilterBar({
  search,
  onSearchChange,
  modelFilter,
  modelInput,
  onModelInputChange,
  onModelSelect,
  onModelClear,
  categoryFilter,
  categoryInput,
  onCategoryInputChange,
  onCategorySelect,
  onCategoryClear,
}: AssetFilterBarProps) {
  return (
    <div className="flex flex-col items-stretch gap-3 md:flex-row md:items-end">
      <div className="relative flex-1">
        <Search className="text-muted-foreground absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2" />
        <Input
          placeholder="Geräte suchen…"
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          className="pl-9"
        />
      </div>
      <div className="w-full space-y-1 md:w-64">
        <label className="text-muted-foreground text-xs font-medium">Modell</label>
        <div className="relative">
          <SearchCombobox
            placeholder="Modell filtern…"
            queryKey="model-filter"
            searchFn={(query) =>
              searchModels(query).then((results) => results.map((m) => ({ id: m.id, label: m.name, data: m })))
            }
            value={modelInput}
            onInputChange={onModelInputChange}
            onSelect={(result) => onModelSelect(result.data as SnipeItModel)}
          />
          {modelFilter && (
            <button
              type="button"
              className="text-muted-foreground hover:text-foreground absolute top-1/2 right-2 -translate-y-1/2"
              onClick={onModelClear}
              aria-label="Modellfilter entfernen"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          )}
        </div>
      </div>
      <div className="w-full space-y-1 md:w-64">
        <label className="text-muted-foreground text-xs font-medium">Kategorie</label>
        <div className="relative">
          <SearchCombobox
            placeholder="Kategorie filtern…"
            queryKey="category-filter"
            searchFn={(query) =>
              searchCategories(query).then((results) => results.map((c) => ({ id: c.id, label: c.name, data: c })))
            }
            value={categoryInput}
            onInputChange={onCategoryInputChange}
            onSelect={(result) => onCategorySelect(result.data as SnipeItCategory)}
          />
          {categoryFilter && (
            <button
              type="button"
              className="text-muted-foreground hover:text-foreground absolute top-1/2 right-2 -translate-y-1/2"
              onClick={onCategoryClear}
              aria-label="Kategoriefilter entfernen"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
